<template>
  <div>
    <div class="inner clearfix">
      <div class="workleft fl">
        <!-- <taskleft :lessionData="lessionData" ref="treeList"></taskleft> -->
        <chapterid
          @chapterid="chapterid"
          @zjgid="zjgid"
          @zjsidCopy="zjsidCopy"
        ></chapterid>
      </div>
      <div class="fr box">
        <navList></navList>
      </div>
    </div>
  </div>
</template>
<script>

import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
import Taskleft from "../../components/common/nav.vue";
import chapterid from "../../components/testPaper/chapterid";
import navList from "@/components/prepareLessons/navList.vue";
import URL from "@/api/index";
export default {
  name: "issuework",
  data() {
    return {
      // chapterid: [],
      lessionData: [],
      chapteriddata: {
        gid: "",
        sid: 1,
      },
      formatypearr: [
        { fmttype_name: "全部", fmttype_id: 0 },
        { fmttype_name: "容易", fmttype_id: 1 },
        { fmttype_name: "较易", fmttype_id: 2 },
        { fmttype_name: "一般", fmttype_id: 3 },
        { fmttype_name: "较难", fmttype_id: 4 },
        { fmttype_name: "困难", fmttype_id: 5 },
      ],
    };
  },
  components: {
    chapterid,
    Taskleft,
    top,
    navMenu,
    navList,
  },
  created() {
    // this.chapterid = JSON.parse(localStorage.getItem("chapterid"));
    // this.chapterList();
  },
  mounted() {
    
  },
  methods: {
   
    //章节题型筛选
    zjgid(val) {
      this.present = val;
      this.chapteriddata.gid = val;
      this.getQuestionType(this.chapteriddata);
    },
    zjsidCopy(val) {
      this.present = val;
      this.chapteriddata.sid = val;
      this.getQuestionType(this.chapteriddata);
    },
    //章节试题筛选
    chapterid(val) {},
    getQuestionType(e) {
      //获取章节题库题型
      var data = {
        sid: e.sid,
        gid: e.gid,
      };
      this.$post(URL.getQuestionType, data).then((res) => {
        this.gettypelist = [];
        this.gettypelist = this.gettypelist
          .concat(
            { type_id: 0, type_name: "全部" }
            // { type_id: "999", type_name: "其他" }
          )
          .concat(res.result);
      });
    },
  },
};
</script> 
<style scoped>
.workleft {
  width: 272px;
  background: none;
  /* padding: 0 10px 0 0; */
}
body,
html,
div,
blockquote,
img,
label,
p,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
ul,
ol,
li,
dl,
dt,
dd,
form,
a,
fieldset,
input,
th,
td,
i,
em {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
}

.box {
  margin-top: 20px;
}
</style>